import { post } from "@/util/http";
import { Message } from "element-ui";
//  /api/activity/getAdJumpLink

export const toMoreActivity = async (jump_type = 100) => {
  try {
    const res = await post({ url: "/api/activity/getAdJumpLink", data: { jump_type } });
    console.log("toNbaActivity", res);
    const {
      data: { data, status, msg },
    } = res;
    if (status !== 0) return Message.error(msg || "请求失败");
    const { url } = data;
    if (url) window.open(url, "_blank");
    else Message.error("url 错误");
  } catch (error) {
    Message.error(error.message || "请求异常");
  }
};
